import { createUri } from '@/utils/util';

export const endpoint = createUri;

export const API_BASE_URL = import.meta.env.VITE_APIURL;
export const AUTH_BASE_URL = import.meta.env.VITE_AUTHURL;

export const TENANT_API_ENDPOINTS = Object.freeze({
	TENANT: 'tenant/get/:id',
});

export const COMPANY_API_ENDPOINTS = Object.freeze({
	INVITE: 'companies/:id/invite',
	CANCEL_INVITE: 'companies/:companyId/invite/:inviteId/cancel',
	ACCEPT_INVITE: 'companies/invite/accept',
	PENDING_INVITES: 'companies/:id/invite/pending',
});

export const OPTIONS_ENDPOINTS = Object.freeze({
	INDUSTRIES: 'options/public/industries',
	TENANT_INDUSTRIES: 'options/tenant/:tenantId/industries',
	GET_GENERAL_HEARD_FROM_OPTIONS: 'generalHeardFromOptions.json',
});
